import script from "./ReferenceStatusText.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReferenceStatusText.vue?vue&type=script&setup=true&lang=ts"

import "./ReferenceStatusText.vue?vue&type=style&index=0&id=1b327740&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b327740"]])

export default __exports__